/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Source_UploadInputs */

const cs_pm_source_upload = /** @type {(inputs: Pm_Source_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrání exportu`)
};

const en_pm_source_upload = /** @type {(inputs: Pm_Source_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload export`)
};

/**
* | output |
* | --- |
* | "Upload export" |
*
* @param {Pm_Source_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_source_upload = /** @type {((inputs?: Pm_Source_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Source_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_source_upload(inputs)
	return cs_pm_source_upload(inputs)
});